export const ContactTypeItems = [
  {
    label: 'Webサイト制作のご相談',
    value: 'Webサイト制作のご相談',
  },
  {
    label: 'Webマーケティング支援のご相談',
    value: 'Webマーケティング支援のご相談',
  },
  {
    label: '運用支援のご相談（Webサイト・SNS・アプリ）',
    value: '運用支援のご相談（Webサイト・SNS・アプリ）',
  },
  {
    label: 'その他のご相談',
    value: 'その他のご相談',
  },
]
